import React, { useState } from 'react'

import MapPicker from 'react-google-map-picker'
import MobileBottomBar from '../Layout/MobileBottomBar';

const DefaultLocation = { lat: 26.9024499, lng: 75.7487665};
const DefaultZoom = 17;

const Map = () => {

  const [defaultLocation, setDefaultLocation] = useState(DefaultLocation);

  const [location, setLocation] = useState(defaultLocation);
  const [markerPosition, setMarkerPosition] = useState(DefaultLocation);
  const [zoom, setZoom] = useState(DefaultZoom);

  function handleChangeLocation (lat, lng){
    setLocation({lat:lat, lng:lng});
    setMarkerPosition({ lat, lng }) 
  }
 
  
  function handleChangeZoom (newZoom){
    setZoom(newZoom);
  }

  function handleResetLocation(){
    setDefaultLocation({ ... DefaultLocation});
    setZoom(DefaultZoom);
  }
//   const markerIconUrl = "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"
  const markerIconUrl = "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"; 
  return (
    <>

<section className="checkout-sec tp-space mt-4">
<div className="container">
  <button onClick={handleResetLocation}>Reset Location</button>
  <label>Latitute:</label><input type='text' value={location.lat} disabled/>
  <label>Longitute:</label><input type='text' value={location.lng} disabled/>
  <label>Zoom:</label><input type='text' value={zoom} disabled/>
  
  <MapPicker defaultLocation={defaultLocation}
    zoom={zoom}
    mapTypeId="roadmap"
    style={{height:'700px'}}
    onChangeLocation={handleChangeLocation} 
    markerIcon={markerIconUrl}
    onChangeZoom={handleChangeZoom}
    mapStyles={{
        cursor: 'pointer',  
      }}
    
    apiKey='AIzaSyDwOFrgNmM51uT1F1zg_L0Em5ujW9obcHk'/>
    </div>
    </section>

    {/* Mobile Bottom Bar */}
    <MobileBottomBar />
  </>
  );
}

export default Map